/* Selah + Stone — pre-order modes on the product page.
   Renders, for the SELECTED variant:
     · the "Pre-order & Save" pill under the price          (strategy only)
     · the button cards — two for strategy, one for genuine/travel pre-order
     · the stock timeline under the buttons
   Data: <script data-ss-po-data> from snippets/ss-po-data.liquid.
   Add to cart always goes through the theme's own <product-form> (cart drawer,
   error handling, Pre-order ETA sync all unchanged): the cards only add the
   right line-item properties, then press the theme's hidden submit button.
   Anything that isn't a strategy / genuine / travel pre-order keeps the theme's
   normal button untouched. */
(function () {
  'use strict';

  var MON = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var ICON = {
    tag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.4"/></svg>',
    cal: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4.5" width="18" height="16" rx="2"/><path d="M3 9h18M8 2.5v4M16 2.5v4"/></svg>',
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1" y="5" width="14" height="12" rx="1.5"/><path d="M15 9h4l3 3v5h-7"/><circle cx="6" cy="18.5" r="2"/><circle cx="18" cy="18.5" r="2"/></svg>',
    hour: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2h12M6 22h12M7 2c0 5 10 7 10 10S7 17 7 22M17 2c0 5-10 7-10 10s10 5 10 10"/></svg>',
    needle: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 4 6 18"/><ellipse cx="18" cy="6" rx="1.4" ry="2.6" transform="rotate(45 18 6)"/><path d="M6 18c-2 1-3 2-2 3s3-1 3-2-2-3-4-3"/></svg>',
    ban: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="m5.7 5.7 12.6 12.6"/></svg>'
  };

  // ── formatting ──────────────────────────────────────────────────────────────
  function money(cents) {
    var n = Math.round(cents) / 100;
    var s = n % 1 === 0 ? String(n) : n.toFixed(2);
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function parts(iso) { var p = String(iso || '').split('-'); return p.length === 3 ? { y: +p[0], m: +p[1], d: +p[2] } : null; }
  function day(iso, withYear) { var p = parts(iso); return p ? MON[p.m - 1] + ' ' + p.d + (withYear ? ', ' + p.y : '') : ''; }
  // Never show a date that's already happened: once we're inside a window (or
  // past an estimate), the earliest date shown is TOMORROW (Melbourne).
  function tomorrowIso() {
    var t = parts(todayIso()), d = new Date(Date.UTC(t.y, t.m - 1, t.d + 1));
    return d.toISOString().slice(0, 10);
  }
  function notPast(iso) { if (!parts(iso)) return iso; var tm = tomorrowIso(); return iso < tm ? tm : iso; }
  function range(from, to) {
    if (parts(from) && parts(to)) { var nf = notPast(from); if (nf <= to) from = nf; }
    var a = parts(from), b = parts(to);
    if (!a || !b) return '';
    return a.m === b.m ? MON[a.m - 1] + ' ' + a.d + ' – ' + b.d : day(from) + ' – ' + day(to);
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function todayIso() {
    var f = new Intl.DateTimeFormat('en-CA', { timeZone: 'Australia/Melbourne', year: 'numeric', month: '2-digit', day: '2-digit' });
    return f.format(new Date());
  }
  function daysBetween(a, b) { return (Date.UTC(b.y, b.m - 1, b.d) - Date.UTC(a.y, a.m - 1, a.d)) / 864e5; }

  // ── which view does this variant get? ───────────────────────────────────────
  // strategy : two cards + pill   (mode strategy, eligible, in stock, not already discounted, no PO dates)
  // genuine  : one pre-order card (variant has PO pre-order dates; wins in every mode)
  // travel   : one pre-order card (mode travel; dates are the travel ship window)
  // none     : theme default button
  function viewFor(data, v) {
    if (!v || !v.available) return 'none';
    if (v.from && v.to) {
      var travel = data.mode === 'travel' && !(v.timeline && v.timeline.run);
      return travel ? 'travel' : 'genuine';
    }
    if (data.mode === 'strategy' && v.eligible && !v.cmp && v.poPrice && data.window.from && data.window.to) return 'strategy';
    return 'none';
  }

  // ── pill (strategy) ─────────────────────────────────────────────────────────
  function pillHtml(data, v) {
    var save = v.price - v.poPrice;
    return '<div class="ss-po-pill">' + ICON.tag +
      '<span class="pp-l"><b>Pre-order &amp; Save:</b> <s class="pp-was">' + money(v.price) + '</s> <b class="pp-now">' + money(v.poPrice) + '</b></span>' +
      '<span class="pp-div" aria-hidden="true"></span>' +
      '<span class="pp-save">Save ' + money(save) + '</span>' +
      '<span class="pp-pct">Save ' + data.pct + '%</span></div>';
  }

  // ── cards ───────────────────────────────────────────────────────────────────
  function card(o) {
    return '<div class="ss-choice' + (o.hero ? ' hero' : '') + '">' +
      (o.ribbon ? '<span class="ss-ribbon">' + o.ribbon + '</span>' : '') +
      '<div class="ss-choice-top"><span class="ss-ci">' + o.icon + '</span>' +
      '<div class="ss-choice-meta"><div class="ss-choice-label">' + o.label + '</div><div class="ss-choice-sub">' + o.sub + '</div></div>' +
      '<div class="ss-choice-price">' + o.price + '</div></div>' +
      '<button type="button" class="ss-choice-cta ' + (o.fill ? 'fill' : 'ghost') + '" data-ss-action="' + o.action + '">' + o.cta + '</button></div>';
  }
  function discounted(was, now) {
    return '<span class="ss-cp-was">' + money(was) + '</span><span class="ss-cp">' + money(now) + '</span>' +
      '<span class="ss-savechip">' + ICON.tag + 'Save ' + money(was - now) + '</span>';
  }
  function cardsHtml(data, v, view) {
    if (view === 'strategy') {
      var save = money(v.price - v.poPrice);
      return '<div class="ss-chooser">' +
        card({ hero: true, ribbon: 'Most popular · Save ' + data.pct + '%', icon: ICON.cal, label: 'Pre-order &amp; save',
          sub: 'Ships ' + range(data.window.from, data.window.to), price: discounted(v.price, v.poPrice),
          fill: true, action: 'preorder', cta: 'Pre-order &amp; Save ' + save + ' →' }) +
        card({ icon: ICON.truck, label: 'Want it now?', sub: 'In stock · ready to ship',
          price: '<span class="ss-cp sm">' + money(v.price) + '</span>', fill: false, action: 'now', cta: 'Add to cart · ships now' }) +
        '</div>';
    }
    var est = view === 'genuine' ? 'Est. ships ' : 'Ships ';
    // Genuine/travel pre-order: same eye-catching ribbon as strategy, with the real
    // saving from the compare-at price (no ribbon % when there's no compare-at).
    var gPct = v.cmp && v.cmp > v.price ? Math.round((1 - v.price / v.cmp) * 100) : 0;
    return '<div class="ss-chooser">' +
      card({ hero: true, ribbon: gPct ? 'Pre-Order · Save ' + gPct + '%' : 'Pre-Order', icon: ICON.cal, label: 'Pre-order', sub: est + range(v.from, v.to),
        price: v.cmp ? discounted(v.cmp, v.price) : '<span class="ss-cp">' + money(v.price) + '</span>',
        fill: true, action: 'dated', cta: 'Pre-order now →' }) +
      '</div>';
  }

  // ── stock timeline ──────────────────────────────────────────────────────────
  function badge(cls, inner) { return '<span class="ss-chip ' + cls + '">' + inner + '</span>'; }
  function hurry(pct, of) { return badge('amber', ICON.hour + '<span>Hurry, only <b class="ss-ct" data-to="' + pct + '">' + pct + '</b>% ' + (of || '') + 'left!</span>'); }
  function row(o) {
    return '<div class="ss-row ' + o.r + ' ' + (o.cls || '') + '"><div class="ss-in"><div><div class="ss-ti">' + o.ti + '</div>' +
      (o.vl ? '<div class="ss-vl">' + o.vl + '</div>' : '') + '</div>' + (o.badge || '') + '</div>' +
      (o.meter ? '<div class="ss-meter ' + o.meter[0] + '"><i style="--to:' + o.meter[1] + '%"></i></div>' : '') +
      (o.lab ? '<div class="ss-mlab"><span>' + o.lab[0] + '</span><span>' + o.lab[1] + '</span></div>' : '') + '</div>';
  }
  function prevRow(t) {
    var p = t.prev;
    if (!p) return '';
    return row({ r: 'r1', ti: 'Previous batch · ' + day(p.landed, true), badge: badge('olive', 'Sold out in ' + p.weeks + ' week' + (p.weeks === 1 ? '' : 's') + '!'),
      meter: ['done', 100], lab: ['Landed ' + day(p.landed), 'Sold out ' + day(p.soldOut)] });
  }
  function prodProgress(next) {
    var a = parts(next.started), b = parts(next.arrives), t = parts(todayIso());
    if (!a || !b || !t) return 50;
    var total = daysBetween(a, b);
    return total > 0 ? Math.max(4, Math.min(96, Math.round((daysBetween(a, t) / total) * 100))) : 50;
  }
  function timelineHtml(data, v, view) {
    var t = v.timeline;
    if (!t) return '';
    var head, rows = [], foot, headCls = '', railCls = '';

    if (view === 'genuine') {
      var run = t.run || {};
      // Only say "sold out" when the warehouse really is empty.
      var stocked = t.inStock === true;
      head = stocked ? 'Pre-order now' : 'Sold out — reserve from the next run'; headCls = 'amber';
      rows.push(prevRow(t));
      rows.push(stocked
        ? row({ r: 'r2', ti: 'In warehouse now', vl: 'Limited stock in the warehouse.' })
        : row({ r: 'r2', cls: 'off', ti: 'In warehouse now', vl: 'None left in the warehouse. Pre-order from our next production run.', badge: badge('grey', 'Sold out!'), meter: ['left', 0] }));
      if (t.run) {
        rows.push(row({ r: 'r3', cls: 'hot', ti: 'Currently in production · pre-order now', vl: 'Est. ships ' + range(v.from, v.to),
          badge: run.pctLeft != null && run.pctLeft <= 35 ? hurry(run.pctLeft, 'of this run ') : badge('olive', ICON.needle + ' In production'),
          meter: ['left', run.pctLeft != null ? run.pctLeft : 100],
          lab: [run.qty ? 'Quantity in production: ' + run.qty + ' pcs' : '', run.arrives ? 'Est. arrives ' + day(notPast(run.arrives)) : ''] }));
      } else {
        rows.push(row({ r: 'r3', cls: 'hot', ti: 'Next dispatch · pre-order now', vl: 'Est. ships ' + range(v.from, v.to) }));
      }
      foot = 'Reserve yours before this run is gone too.';
    } else if (view === 'travel') {
      head = 'Pre-order now — next dispatch ' + range(v.from, v.to); headCls = 'amber';
      rows.push(prevRow(t));
      rows.push(row({ r: 'r2', cls: 'off', ti: 'Ready to ship now', vl: 'None available to ship right now. Pre-order for our next dispatch.', badge: badge('grey', 'Pre-order only'), meter: ['left', 0] }));
      rows.push(row({ r: 'r3', cls: 'hot', ti: 'Next dispatch · pre-order now', vl: 'Ships ' + range(v.from, v.to),
        badge: t.pctLeft != null && t.pctLeft <= 35 ? hurry(t.pctLeft, 'of this batch ') : '',
        meter: t.pctLeft != null ? ['left', t.pctLeft] : null,
        lab: [t.batchQty ? 'Batch size: ' + t.batchQty + ' pcs' : '', 'Ships from ' + day(v.from)] }));
      foot = '<b>Reserve yours before this batch sells out!</b>';
    } else {
      // In stock: strategy, plus hype / sale / normal with no pre-order wording.
      head = 'In stock — ready to ship';
      rows.push(prevRow(t));
      rows.push(row({ r: 'r2', cls: 'hot', ti: 'In warehouse now', vl: 'In stock, ready to ship.',
        badge: t.pctLeft != null && t.pctLeft <= 35 ? hurry(t.pctLeft) : '', meter: t.pctLeft != null ? ['left', t.pctLeft] : null }));
      if (t.next) {
        rows.push(row({ r: 'r3', ti: 'Next batch', vl: 'Est. arrives ' + day(notPast(t.next.arrives)), badge: badge('olive', ICON.needle + ' In production'),
          meter: ['prod', prodProgress(t.next)], lab: ['<b>Production started ' + day(t.next.started) + '</b>', 'Est. arrives ' + day(notPast(t.next.arrives))] }));
        foot = data.mode === 'sale' ? 'Sale price while this batch lasts.' : data.mode === 'hype' ? 'Ready to ship today.' : '<b>Reserve yours before this batch sells out again!</b>';
      } else if (t.final) {
        head = 'Final batch — this colourway is being retired'; headCls = 'red'; railCls = 'ends';
        rows.push(row({ r: 'r3', cls: 'deadend', ti: 'After this', vl: 'Not being restocked!', badge: badge('red', ICON.ban + ' Final batch') }));
        foot = 'When it’s gone, it’s gone for good.';
      } else {
        head = 'Order now — our next production run hasn’t started yet!'; headCls = 'red'; railCls = 'ends';
        rows.push(row({ r: 'r3', cls: 'deadend', ti: 'Next batch', vl: 'Not in production yet', badge: badge('red', ICON.needle + ' Not started') }));
        foot = '<span class="ss-ft-sub">We haven’t started our next production run on these yet, so there’s nothing to reserve beyond what’s here.</span>Order now before stock is gone!';
      }
    }
    return '<div class="ss-stl" data-ss-stl><div class="ss-stl-head ' + headCls + '"><span class="ss-dot"></span> ' + head + '</div>' +
      '<div class="ss-rail ' + railCls + '">' + rows.join('') + '</div>' +
      '<div class="ss-stl-foot' + (headCls === 'red' ? ' red' : '') + '">' + foot + '</div></div>';
  }

  // ── motion: plays once when the timeline scrolls into view ─────────────────
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function animate(el) {
    if (reduce || !('IntersectionObserver' in window) || !el) return;
    el.classList.add('armed');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        e.target.classList.add('go');
        [].forEach.call(e.target.querySelectorAll('.ss-ct'), function (ct) {
          var to = +ct.getAttribute('data-to'), t0 = null, delay = 850, dur = 1500;
          function step(ts) {
            if (t0 === null) t0 = ts;
            var k = Math.min(1, Math.max(0, (ts - t0 - delay) / dur));
            ct.textContent = Math.round(100 + (to - 100) * (1 - Math.pow(1 - k, 3)));
            if (k < 1) requestAnimationFrame(step);
          }
          ct.textContent = 100; requestAnimationFrame(step);
        });
      });
    }, { threshold: 0.4 });
    io.observe(el);
  }

  // ── wiring per product section ──────────────────────────────────────────────
  function setup(dataEl) {
    var sectionId = dataEl.getAttribute('data-ss-po-data');
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var formId = 'product-form-' + sectionId;
    var form = document.getElementById(formId);
    var productForm = document.getElementById('ProductForm-' + sectionId);
    var pillSlot = document.querySelector('[data-ss-po-pill="' + sectionId + '"]');
    var cardSlot = document.querySelector('[data-ss-po-cards="' + sectionId + '"]');
    var tlSlot = document.querySelector('[data-ss-po-timeline="' + sectionId + '"]');
    if (!form || !productForm) return;

    var current = { view: 'none', id: null };

    function variantId() {
      var input = form.querySelector('[name="id"]') || document.querySelector('[name="id"][form="' + formId + '"]');
      return input ? String(input.value) : null;
    }

    function render() {
      var id = variantId();
      var v = data.variants[id];
      var view = viewFor(data, v);
      current = { view: view, id: id, v: v };
      productForm.classList.toggle('ss-po-active', view !== 'none');
      document.documentElement.classList.toggle('ss-po-strategy', view === 'strategy');
      if (pillSlot) {
        var isStrat = view === 'strategy';
        pillSlot.innerHTML = isStrat ? '<div class="ss-po-or">or</div>' + pillHtml(data, v) : '';
        // The "or" takes the place of the "GST included." line on strategy items.
        var priceBox = pillSlot.previousElementSibling;
        if (priceBox) priceBox.classList.toggle('ss-po-hide-tax', isStrat);
      }
      if (cardSlot) cardSlot.innerHTML = view !== 'none' ? cardsHtml(data, v, view) : '';
      if (tlSlot) {
        tlSlot.innerHTML = timelineHtml(data, v, view);
        animate(tlSlot.querySelector('[data-ss-stl]'));
      }
    }

    // Line-item properties for the chosen card. Removed again right after the
    // theme's submit handler has read the form (it builds FormData synchronously).
    function addProps(props) {
      var added = [];
      Object.keys(props).forEach(function (k) {
        var i = document.createElement('input');
        i.type = 'hidden'; i.name = 'properties[' + k + ']'; i.value = props[k]; i.setAttribute('data-ss-tmp', '');
        form.appendChild(i); added.push(i);
      });
      return function () { added.forEach(function (i) { i.remove(); }); };
    }

    function submitWith(props, btn) {
      var submit = form.querySelector('[type="submit"][name="add"]:not(.no-js)') || form.querySelector('[type="submit"]');
      var cleanup = addProps(props);
      if (btn) { btn.classList.add('busy'); setTimeout(function () { btn.classList.remove('busy'); }, 1500); }
      if (form.requestSubmit) form.requestSubmit(submit || undefined); else if (submit) submit.click();
      setTimeout(cleanup, 0);
    }

    function testFlag() {
      if (!data.testOnly) return Promise.resolve();
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _ss_test: '1' } }) }).catch(function () {});
    }

    if (cardSlot) cardSlot.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ss-action]');
      if (!btn) return;
      var action = btn.getAttribute('data-ss-action');
      if (action === 'preorder') {
        // Stamp the same window the shopper sees (never a start date in the past).
        var wf = notPast(data.window.from), wFrom = wf <= data.window.to ? wf : data.window.from;
        var props = Object.assign({ _ss_po: '1' },
          window.SelahPreorder ? window.SelahPreorder.properties(wFrom, data.window.to) : {});
        testFlag().then(function () { submitWith(props, btn); });
      } else {
        // "ships now" and genuine/travel pre-order: the theme stamps what it needs.
        submitWith({}, btn);
      }
    });

    // Sticky add-to-cart bar: for strategy items, send shoppers to the two
    // choices instead of silently adding at full price.
    document.addEventListener('click', function (e) {
      if (current.view !== 'strategy') return;
      var b = e.target.closest('#custom-sticky-cart .add-cart-custom-new');
      if (!b || !cardSlot) return;
      e.preventDefault(); e.stopImmediatePropagation();
      cardSlot.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    }, true);

    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') setTimeout(render, 0);
    });
    render();
  }

  function init() { [].forEach.call(document.querySelectorAll('script[data-ss-po-data]'), setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
